import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Tab, Tabs } from "@mui/material";

import React, { useEffect, useState } from "react";
import CampaignLeadDetailTab from "../../components/CampaignLeadTabs/CampaignLeadDetailTab";
import { useNavigate, useParams } from "react-router-dom";
import { getCampaignLeadByIdApi } from "../../store/saga/requests/campaignRequests";
import CampaignLeadAddDisposition from "../../components/CampaignLeadTabs/CampaignLeadDisposition";
import { store } from "../../store/store";
import { getCampaignLeadData } from "../../store/actions/campaignActions";
import CampaignLeadLogsTab from "../../components/CampaignLeadTabs/CampaignLeadLogsTab";

export default function CampaignLeadById() {
  const { id } = useParams();
  const [value, setValue] = useState<string>("1");
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  useEffect(() => {
    store.dispatch(getCampaignLeadData({ leadId: Number(id) }));
  }, [id]);
  let navigate = useNavigate();

  return (
    <Box sx={{ width: "100%", typography: "body1" }}>
      <button className="hover:bg-white px-2 py-1 rounded-lg" onClick={() => navigate(-1)}>{"Go Back"}</button>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList
            onChange={handleChange}
            textColor="secondary"
            indicatorColor="secondary"
          >
            <Tab label="Lead Details" value="1" />
            <Tab label="Logs" value="2" />
            <Tab label="Disposition" value="3" />
          </TabList>
        </Box>
        <TabPanel value="1">
          <CampaignLeadDetailTab />
        </TabPanel>
        <TabPanel value="2">
          <CampaignLeadLogsTab />
        </TabPanel>
        <TabPanel value="3">
          <CampaignLeadAddDisposition />
        </TabPanel>
      </TabContext>
    </Box>
  );
}
